import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";

function DashboardUIHFullScreenListener({ children, history }) {
  const [isFullScreen, setisFullScreen] = useState(false);
  const handleEvent = (event) => {
    if (event.keyCode === 13) {
      toggleFullScreen();
    }
  };

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setisFullScreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        setisFullScreen(false);
      }
    }
  };
  const checkFullScreen = () => {
    if (document.fullscreenElement) {
      history.push("/dashboard/monitor");
      setisFullScreen(true);
    } else {
      history.push("/dashboard");
      setisFullScreen(false);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleEvent);
    window.addEventListener("fullscreenchange", checkFullScreen);

    return () => {
      window.removeEventListener("keydown", handleEvent);
      window.removeEventListener("fullscreenchange", checkFullScreen);
    };
  }, []);
  return (
    <>
      {isFullScreen ? (
        <div className={"uih-dashboard-fullscreen"}>{children}</div>
      ) : (
        children
      )}
    </>
  );
}

export default withRouter(DashboardUIHFullScreenListener);
